import React from "react"
import EngineIDNavBar from "@components/EngineIDNavBar"
import BannerContactUs from "./BannerContactUs"
import ContactSection from "./ContactSection"
import CTASignUpLong from "@components/CTASignUpLong"
import Footer from "@components/Footer"
import "@styles/global.scss"
import "@styles/custom-bootstrap.scss"

const Contact = props => {
  return (
    <div>
      <EngineIDNavBar />
      <BannerContactUs />
      <div className={"container-fluid"}>
        <div className={"maxWidth"}>
          <ContactSection></ContactSection>
          <CTASignUpLong />
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default Contact
